export const CHARTCOLORS = [
    '#84C1FB', '#C2B1FE', '#FEB9B5', '#FFCB03', '#4BEDA9', '#A7C1DB',
    '#D7A9FE', '#FDA77D', '#F7FFCB', '#1DD4AB', '#A4BAFB', '#FB9AF2',
    '#E0B483', '#CED89E', '#62CCCD', '#C6D3FF', '#F7A1D7', '#FFEED9',
    '#B9DDA1', '#86C5DB', '#B1B7FA', '#FF9EC2', '#EBCF98', '#BFFFBC',
    '#62C6FD', '#B3B6FD', '#FCA4A9', '#FFA3A3', '#D2BA69', '#2ED82E'
]

export const STATUSCOLORS = {
    ACTIVE: ["#3498DB", "#E8F5FE"],
    JOINED: ["#17b491", "#eaf5f3"],
    RESIGNED: ["#f48080", "#feecec"],
    INCOMING: ["#8385B8", "#E7EEFF"],
    RESIGNING: ["#FB8B4F", "#FAF2ED"],
    ONLEAVE: ["#FFCB03", "#FDFFF4"],
}
